<template>
  <Form as="div" ref="form">
    <div v-if="$store.getters['cprConsent/showMainModal']">
      <transition v-cloak name="modal">
        <v-modal
          :is-open="$store.state.cprConsent.stepOne"
          :show-close-button="$store.state.cprConsent.showModalCloseButton"
          modal-class="alt-modal"
          @close="close"
        >
          <template #title>
            <h2 data-test-cpr-consent-main-title v-html="vueModel.MainModalTitle" />
          </template>
          <template #content>
            <div>
              <p
                class="paragraph-text-large"
                data-test-cpr-consent-main-upperbody
                v-html="vueModel.UpperBody"
              />
              <h3 data-test-cpr-consent-main-consenttitle v-html="vueModel.ConsentTitle" />
              <gray-content-wrapper>
                <template #content>
                  <div>
                    <radio-buttons-checkbox-style
                      :model-value="hasAcceptedCprConsent"
                      name="cpr-consent"
                      class="no-margin-bottom"
                      :options="checkBoxOptions"
                      :required-validation-override="decodeRequiredValidationMessage()"
                      @update:modelValue="
                        (e) => {
                          updateHasAcceptedCprConsent(e);
                        }
                      "
                    />
                    <info-box
                      v-if="showDeclineValidationMessage"
                      arrow-align="left"
                      info-box-class="info-box-warning-alt"
                      v-html="vueModel.DeclineValidationMessage"
                    />
                    <p data-test-cpr-consent-main-consenttext v-html="vueModel.ConsentText" />
                    <p
                      class="no-margin-bottom"
                      data-test-cpr-consent-main-lowerbody
                      v-html="vueModel.LowerBody"
                    />
                  </div>
                </template>
              </gray-content-wrapper>
            </div>
          </template>
          <template #buttons>
            <div>
              <div class="row">
                <div class="columns small-12 medium-8 medium-offset-2">
                  <button
                    class="button large"
                    :disabled="submitButtonDisabled"
                    @click="submit"
                    v-html="vueModel.ButtonText"
                  />
                </div>
              </div>
            </div>
          </template>
        </v-modal>
      </transition>
    </div>
  </Form>
</template>

<script>
import GrayContentWrapper from '@/components/Feature/GrayContentWrapper/GrayContentWrapper.vue';

import RadioButtonsCheckboxStyle from './RadioButtonsCheckboxStyle.vue';
import InfoBox from '@/components/UI/InfoBox.vue';
import UtilityFunctions from '@/common/UtilityFunctions.js';

export default {
  name: 'CprConsentMainModal',
  components: {
    
    GrayContentWrapper,
    InfoBox,
    RadioButtonsCheckboxStyle
  },
  computed: {
    vueModel() {
      return this.$store.state.cprConsent.vueModel;
    },
    checkBoxOptions() {
      return [
        {
          Text: this.vueModel.AcceptLabel,
          Value: true
        },
        {
          Text: this.vueModel.DeclineLabel,
          Value: false
        }
      ];
    },
    showDeclineValidationMessage() {
      const hasAcceptedCprConsent = this.vueModel.CprConsentTemplateModel.HasAcceptedCprConsent;
      return hasAcceptedCprConsent !== null && !hasAcceptedCprConsent;
    },
    submitButtonDisabled() {
      const hasAcceptedCprConsent = this.vueModel.CprConsentTemplateModel.HasAcceptedCprConsent;
      return (
        hasAcceptedCprConsent !== null &&
        hasAcceptedCprConsent === this.$store.state.cprConsent.initialConsent
      );
    },
    hasAcceptedCprConsent: {
      get() {
        return this.$store.state.cprConsent.vueModel.CprConsentTemplateModel.HasAcceptedCprConsent;
      },
      set(value) {
        this.$store.commit('cprConsent/updateHasAcceptedCprConsent', value);
      }
    }
  },
  mounted() {
    this.$store.dispatch('cprConsent/setStepOne', true);
    this.$store.dispatch('Events/register', {
      event: 'cpr-consent-modal-shown',
      id: 'cprConsentModal',
      vm: this
    });
  },
  methods: {
    decodeRequiredValidationMessage() {
      return UtilityFunctions.decodeHtml(this.vueModel.RequiredValidationMessage);
    },
    async submit() {
      let resultObj = await this.$refs.form.validate();
      if (resultObj.valid) {
        await this.$store.dispatch('cprConsent/submitStepOne');
      }
    },
    close() {
      this.$store.dispatch('cprConsent/closeModalsByCross');
    },
    updateHasAcceptedCprConsent(value) {
      this.hasAcceptedCprConsent = value;
    }
  }
};
</script>
